export default __webpack_public_path__ + "static/diver-f9c01c9bae0d85ba615d721b82969564.png";